module.exports = __webpack_public_path__ + "assets/img/24_1064_big.68784a37.jpg";